// Logo da Flux Delivery, usada na tela de configuração e no painel (recebedor).
export const FLUX_LOGO_URL =
    "https://clientefiel.s3.us-east-1.amazonaws.com/logos/fluxfarma.jpg"
